module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 07 Farma Pasa - Opravdanja.7c6adeb0.mp3";